import store from '@pt/store'
import { hasPermission as permission } from '@com/permission'
import componentConstructor from '@com/permission/component-constructor'

export const getRoles = () => {
  // 动态参数制作页面
  const materialMakerPages = [
    'creative.template',
    'creative.common-template',
    'creative.template.custom',
    'creative.template.dco',
    'template.custom',
    'template.dco',
    'template.multi-custom',
    'common-template.custom',
    'common-template.dco',
    'common-template.multi-custom',
  ]
  if (
    materialMakerPages.some((item) => item === store.getters.currentRouter.name)
  ) {
    return [
      ...store.state.creative.template.permissions,
      ...store.getters.roles,
    ]
  }
  return store.getters.roles
}

/**
 * 权限判断
 * @param {string|string[]} latchkey 权限 key 值
 * @param {string} [type] 当第一个参数是数组的时候，type 可选 or 或 and，默认 and
 * @param {array} [roles] 权限 key 列表
 */
export const hasPermission = (latchkey, type, roles) => {
  // permissionkey判断条件包含后端返回权限key + 存在对应服务套餐 + 套餐有限期
  // 注意：套餐过期了，后端不会返回套餐对应的权限key
  return permission(latchkey, type, roles || getRoles())
}

const PermissionManager = componentConstructor(hasPermission)

export default PermissionManager
